import { useSyncExternalStore } from "react";
import { safeSessionGet, safeSessionSet } from "@wags/tanstack-start/browser";
import {
    ViewerLocationSchema,
    type ViewerLocation,
} from "./viewer-location.contract";

const STORAGE_KEY = "wags:selected-location";

function subscribe(listener: () => void) {
    window.addEventListener(STORAGE_KEY, listener);
    return () => window.removeEventListener(STORAGE_KEY, listener);
}

export function rememberLocationSelection(location: ViewerLocation) {
    if (typeof window === "undefined") return;
    safeSessionSet(STORAGE_KEY, JSON.stringify(location));
    window.dispatchEvent(new Event(STORAGE_KEY));
}

export function useSelectedLocation() {
    const raw = useSyncExternalStore(
        subscribe,
        () => safeSessionGet(STORAGE_KEY),
        () => null,
    );
    return readSelectedLocation(raw);
}

export function readSelectedLocation(raw = safeSessionGet(STORAGE_KEY)) {
    if (!raw) return null;
    try {
        return ViewerLocationSchema.safeParse(JSON.parse(raw)).data ?? null;
    } catch {
        return null;
    }
}
